/** 演示用 mock 数据，后续对接勒里聚刻房间与订单 API */

export const TIME_SLOT_STATUS = {
  active: { label: '进行中', color: '#52c41a' },
  upcoming: { label: '即将开始', color: '#faad14' },
  finished: { label: '已结束', color: '#8c8c8c' },
  idle: { label: '空闲', color: '#595959' },
};

export const MOCK_ROOMS = [
  {
    id: 'room-a',
    name: '派对厅 A',
    floor: '3F',
    capacity: 12,
    theme: '星空主题',
    sessions: [
      {
        id: 'room-a-am',
        slot: '上午场',
        time: '09:00 – 12:00',
        status: 'finished',
        host: '王女士',
        eventTitle: '团队团建',
        guests: [
          { id: 1, name: '王女士', role: '组织者', note: '10 人团队' },
          { id: 2, name: '陈明', role: '成员' },
          { id: 3, name: '刘洋', role: '成员' },
          { id: 4, name: '赵婷', role: '成员' },
        ],
      },
      {
        id: 'room-a-pm',
        slot: '下午场',
        time: '14:00 – 18:00',
        status: 'active',
        host: '张先生',
        eventTitle: '生日派对',
        guests: [
          { id: 1, name: '张先生', role: '寿星', note: '28 岁' },
          { id: 2, name: '李悦', role: '嘉宾' },
          { id: 3, name: '王浩', role: '嘉宾' },
          { id: 4, name: '周琳', role: '嘉宾' },
          { id: 5, name: '孙杰', role: '嘉宾' },
          { id: 6, name: '吴敏', role: '嘉宾' },
        ],
      },
      {
        id: 'room-a-eve',
        slot: '晚上场',
        time: '19:00 – 23:00',
        status: 'upcoming',
        host: '陈先生',
        eventTitle: '求婚惊喜',
        guests: [
          { id: 1, name: '陈先生', role: '主角' },
          { id: 2, name: '林小姐', role: '贵宾', note: '惊喜主角' },
          { id: 3, name: '好友团', role: '亲友', note: '6 人' },
        ],
      },
    ],
  },
  {
    id: 'room-b',
    name: '派对厅 B',
    floor: '3F',
    capacity: 8,
    theme: '复古唱片',
    sessions: [
      {
        id: 'room-b-pm',
        slot: '下午场',
        time: '14:00 – 18:00',
        status: 'active',
        host: '刘女士',
        eventTitle: '闺蜜聚会',
        guests: [
          { id: 1, name: '刘女士', role: '组织者' },
          { id: 2, name: '张琪', role: '闺蜜' },
          { id: 3, name: '何静', role: '闺蜜' },
          { id: 4, name: '马丽', role: '闺蜜' },
        ],
      },
      {
        id: 'room-b-eve',
        slot: '晚上场',
        time: '19:00 – 23:00',
        status: 'upcoming',
        host: '待定',
        eventTitle: '暂无预约',
        guests: [],
      },
    ],
  },
  {
    id: 'room-c',
    name: 'VIP 包间',
    floor: '5F',
    capacity: 6,
    theme: '私人影院',
    sessions: [
      {
        id: 'room-c-eve',
        slot: '晚上场',
        time: '19:00 – 23:00',
        status: 'upcoming',
        host: '黄先生',
        eventTitle: '纪念日',
        guests: [
          { id: 1, name: '黄先生', role: '主角' },
          { id: 2, name: '杨女士', role: '伴侣' },
        ],
      },
    ],
  },
  {
    id: 'room-d',
    name: '露台花园',
    floor: '顶楼',
    capacity: 20,
    theme: '户外派对',
    sessions: [],
  },
];

export function getRoomById(roomId) {
  return MOCK_ROOMS.find((r) => r.id === roomId) || null;
}

export function getActiveSession(room) {
  if (!room?.sessions?.length) return null;
  return room.sessions.find((s) => s.status === 'active') || room.sessions[0];
}

export const MOCK_DANMAKU = [
  { id: 1, user: '李悦', text: '生日快乐！🎂', color: '#ffd666' },
  { id: 2, user: '王浩', text: '气氛拉满！', color: '#95de64' },
  { id: 3, user: '周琳', text: '下一首放《晴天》', color: '#69c0ff' },
  { id: 4, user: '孙杰', text: '投屏准备好了', color: '#ff85c0' },
  { id: 5, user: '吴敏', text: '蛋糕什么时候上？', color: '#b37feb' },
];

export const MOCK_PLAYLIST = [
  { id: 1, title: '晴天', artist: '周杰伦', playing: true },
  { id: 2, title: '告白气球', artist: '周杰伦', playing: false },
  { id: 3, title: '小幸运', artist: '田馥甄', playing: false },
  { id: 4, title: '爱你', artist: '王心凌', playing: false },
];
